import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Button } from 'shared/components';
import { UserDetailsInfo, UserDetailsDetails } from 'modules/user/components';
import { redirectTo } from 'modules/auth/actions/redirectAction';

import theme from './UserProfilePage.scss';

const propTypes = {
  intl: PropTypes.any.isRequired,
};

const UserProfilePage = ({ intl }) => {
  return (
    <div className={ theme.root } id="rootPage">
      <div className={ theme.navHeader }>
        <Button
          testId="back-button"
          buttonType="naked"
          label={ intl.formatMessage({ id: 'General.Back', defaultMessage: '** Back' }) }
          iconName="arrow-left"
          iconPositionLeft
          iconPositionRtlNotReversed
          size="xsmall"
          onClick={ () => redirectTo('/appointments') }
        />
      </div>
      <div className={ theme.scrollableContent }>
        <div className={ theme.content }>
          <UserDetailsInfo />
          <UserDetailsDetails />
        </div>
      </div>
    </div>
  );
};

UserProfilePage.propTypes = propTypes;

export default injectIntl(UserProfilePage);
